import React, { Component } from 'react';
import { Form, Input, Col, Row, Modal } from 'antd';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
    };
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = values;
        handleSubmit(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { handleModalVisible } = this.props;
    const { detail } = this.state;

    return (
      <Modal title="核实" visible onCancel={() => handleModalVisible(false)} onOk={this.submit}>
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <FormItem>
                {getFieldDecorator('record', {
                  initialValue: detail.record,
                })(<Input placeholder="请输入联系记录" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/ModalCheck.js